import {
  Box,
  Drawer,
  DrawerBody,
  DrawerContent,
  DrawerOverlay,
  Text,
} from "@chakra-ui/react";

import { CloseIcon } from "@/components/icons";
import { LogsButton } from "@/components/Button";
import { useNavigate } from "react-router-dom";
import { deleteCustomer } from "@/api/bridge";
import { useUserInfo } from "@/context/UserInfo";

const CautionDrawer = ({
  isOpen,
  onClose,
}: {
  isOpen: boolean;
  onClose: () => void;
}) => {
  const { handleGetCustomer } = useUserInfo();
  const handleDeleteCustomer = async () => {
    try {
      const response = await deleteCustomer();
      console.log(response);
      await handleGetCustomer();
      onClose();
      navigate("/createKyc");
    } catch (error) {
      console.error(error);
    }
  };

  const navigate = useNavigate();
  return (
    <Drawer
      isOpen={isOpen}
      placement="bottom"
      onClose={onClose}
      autoFocus={false}
    >
      <DrawerOverlay />
      <DrawerContent
        sx={{
          padding: "20px 20px",
          background: "#fff",
          borderTopLeftRadius: "20px",
          borderTopRightRadius: "20px",
        }}
      >
        <DrawerBody
          sx={{
            padding: "0",
          }}
        >
          <Box
            sx={{
              position: "relative",
            }}
          >
            <Text
              sx={{
                color: "#D8572B",
                textAlign: "center",
                fontFamily: "DIN",
                fontSize: "24px",
                fontStyle: "normal",
                fontWeight: 700,
              }}
            >
              Caution
            </Text>
            <CloseIcon
              onClick={onClose}
              style={{
                position: "absolute",
                top: "50%",
                right: "0px",
                width: "16px",
                height: "16px",
                cursor: "pointer",
                color: "#333",
                transform: "translateY(-50%)",
              }}
            ></CloseIcon>
          </Box>{" "}
          <Text
            sx={{
              color: "#848484",
              fontSize: "16px",
              marginTop: "30px",
              fontWeight: 700,
            }}
          >
            If you update this information, you would need to restart your KYC/B
            process.
          </Text>
          <LogsButton
            sx={{
              marginTop: "48px",
              fontSize: "20px",
              fontStyle: "normal",
              fontWeight: 500,
            }}
            onClick={() => {
              handleDeleteCustomer();
            }}
          >
            Confirm
          </LogsButton>
        </DrawerBody>
      </DrawerContent>
    </Drawer>
  );
};

export default CautionDrawer;
